module.exports = __webpack_public_path__ + "static/img/light.cf8f316.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index1/light.png
// module id = qhJl
// module chunks = 7